import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "pocket-props-header-container"
};
import store from '@/store';
import { computed, nextTick, onMounted, ref } from 'vue';
import _ from 'lodash';
import { ElSelect, ElButton, ElInput } from 'element-plus';
import { Sort, SortDown, SortUp } from '@element-plus/icons-vue';
export default {
  __name: 'PocketPropsHeader',
  props: {
    hasSort: {
      type: Boolean,
      default: true,
      required: false
    },
    existingTypes: {
      type: Array,
      default: null,
      required: false
    },
    existingTags: {
      type: Array,
      default: null,
      required: false
    }
  },
  emits: ['updateFilter'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const sortOptions = [{
      'id': 1,
      'desc': '价格',
      'value': 'price'
    }, {
      'id': 2,
      'desc': '稀有度',
      'value': 'rare_level'
    }];
    const sortIconList = [Sort, SortUp, SortDown]; // refs

    const selectSort = ref(null);
    const sortMode = ref(0);
    const selectType = ref(null);
    const selectTag = ref(null);
    const search = ref(null); // computed

    const worldOutlook = computed(() => store.state.world_outlook);
    const propsTypes = computed(() => {
      if (!worldOutlook.value) return [];
      return store.state.world_outlook_info[worldOutlook.value.id]?.props_types ?? [];
    });
    const propsTags = computed(() => {
      if (!worldOutlook.value) return [];
      return store.state.world_outlook_info[worldOutlook.value.id]?.props_tags ?? [];
    });
    const typeOptions = computed(() => {
      if (!props.existingTypes) return propsTypes.value;
      return propsTypes.value.filter(item => props.existingTypes.includes(item.id));
    });
    const tagOptions = computed(() => {
      if (!props.existingTags) return propsTags.value;
      return propsTags.value.filter(item => props.existingTags.includes(item.id));
    });
    const sortIcon = computed(() => {
      return sortIconList[sortMode.value];
    }); // functions

    const getData = () => {
      if (propsTypes.value.length === 0) {
        store.dispatch('get_props_types');
      }

      if (propsTags.value.length === 0) {
        store.dispatch('get_props_tags');
      }
    };

    const searchProps = () => {
      let filterInfo = { ...(selectType.value && {
          'select_type': selectType.value
        }),
        ...(selectTag.value && {
          'select_tag': selectTag.value
        }),
        ...(search.value && search.value.trim() !== '' && {
          'search': search.value
        })
      };

      if (selectSort.value && sortMode.value) {
        let sorter_key = selectSort.value;
        let sorter_reverse = 'ASC';
        if (sortMode.value === 2) sorter_reverse = 'DESC';
        filterInfo['select_sort'] = `${sorter_key};${sorter_reverse}`;
      } // console.log('searchProps', JSON.stringify(filterInfo))


      nextTick(() => {
        emits('updateFilter', filterInfo);
      });
    };

    const onSelectFilterChange = _.debounce(searchProps, 300);

    const onInputFilterChange = _.debounce(searchProps, 300);

    const onSortChange = _.debounce(() => {
      if (selectSort.value && sortMode.value === 0) {
        sortMode.value = 1;
      } else if (!selectSort.value && sortMode.value !== 0) {
        sortMode.value = 0;
      }

      searchProps();
    }, 300);

    const onSortModeChange = _.debounce(() => {
      if (selectSort.value) {
        sortMode.value = sortMode.value === 1 ? 2 : 1;
        searchProps();
      }
    }, 300); // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.hasSort ? (_openBlock(), _createBlock(_unref(ElSelect), {
        key: 0,
        modelValue: selectSort.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectSort.value = $event),
        "show-arrow": false,
        clearable: "",
        placeholder: "排序依据",
        "popper-class": "commonPopper",
        class: _normalizeClass(selectSort.value ? 'selected-selector sort-selector' : 'sort-selector'),
        onChange: _unref(onSortChange)
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(sortOptions, item => {
          return _createVNode(_component_el_option, {
            key: item.id,
            label: item.desc,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 64))]),
        _: 1
      }, 8, ["modelValue", "class", "onChange"])) : _createCommentVNode("", true), __props.hasSort ? (_openBlock(), _createBlock(_unref(ElButton), {
        key: 1,
        class: _normalizeClass([sortMode.value !== 0 ? 'is-active' : '']),
        icon: sortIcon.value,
        onClick: _unref(onSortModeChange)
      }, null, 8, ["class", "icon", "onClick"])) : _createCommentVNode("", true), _createVNode(_unref(ElSelect), {
        modelValue: selectType.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => selectType.value = $event),
        "show-arrow": false,
        clearable: "",
        placeholder: "类别筛选",
        "popper-class": "commonPopper",
        class: _normalizeClass(selectType.value ? 'selected-selector' : ''),
        onChange: _unref(onSelectFilterChange)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeOptions.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item.desc,
            value: item.id
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "class", "onChange"]), _createVNode(_unref(ElSelect), {
        modelValue: selectTag.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => selectTag.value = $event),
        "show-arrow": false,
        clearable: "",
        placeholder: "标签筛选",
        "popper-class": "commonPopper",
        class: _normalizeClass(selectTag.value ? 'selected-selector' : ''),
        onChange: _unref(onSelectFilterChange)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagOptions.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item.desc,
            value: item.id
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "class", "onChange"]), _createVNode(_unref(ElInput), {
        modelValue: search.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => search.value = $event),
        maxlength: "16",
        type: "text",
        placeholder: "查找物品",
        onInput: _unref(onInputFilterChange)
      }, null, 8, ["modelValue", "onInput"])]);
    };
  }

};